import React from "react";

function DashboardAdmin() {
  return (
    <div className="container mt-5">
      <h2>Photo Office Dashboard</h2>
      <p>Welcome,Photo Office.</p>
    </div>
  );
}

export default DashboardAdmin;